var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheckCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1-1h24v24H-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 0C4.925 0 0 4.925 0 11s4.925 11 11 11 11-4.925 11-11S17.075 0 11 0zm0 2.129A8.866 8.866 0 0119.871 11 8.866 8.866 0 0111 19.871 8.866 8.866 0 012.129 11 8.866 8.866 0 0111 2.129m6.219 5.778l-1-1.008a.532.532 0 00-.753-.003l-6.27 6.22-2.651-2.674a.532.532 0 00-.753-.003l-1.008 1a.532.532 0 00-.003.752l4.027 4.06c.207.208.544.21.753.002l7.655-7.593a.532.532 0 00.003-.753z",
    fill: "#151A30"
  }))));
}

export default SvgCheckCircle;